export default {
	bizInspectCalWarn: {
		// title and buttons
		alarmRecord: 'Alarm Record',
		alarmStatistics: 'Alarm Statistics',
		export: 'Export',
		ignore: 'Ignore',
		confirm: 'Confirm',
		details: 'Details',
		generateReport: 'Generate Report',
		cancel: 'Cancel',
		ok: 'OK',

		// form labels
		deviceName: 'Device Name',
		deviceNo: 'Device Number',
		orgName: 'Department',
		status: 'Status',
		alarmTime: 'Alarm Time',
		alarmLevel: 'Alarm Level',
		alarmCount: 'Alarm Count',
		alarmTitle: 'Alarm Title',
		startTime: 'Start Time',
		endTime: 'End Time',
		handleStatus: 'Handle Status',
		type: 'Alarm Type',

		// form placeholder
		selectProcessor: 'Select Processor',
		processSuggestion: 'Process Suggestion',
		selectAlarmType: 'Select Alarm Type',
		selectAlarmLevel: 'Select Alarm Level',
		selectHandleStatus: 'Select Handle Status',

		// dialog titles
		selectTimeRange: 'Select Time Range',
		confirmAlarm: 'Confirm Alarm',
		generateReportTitle: 'Generate Report',

		// messages
		confirmIgnore: 'Ignore this alarm?',
		reportGenerating: 'Generating report, please wait...',
		reportSuccess: 'Report generated successfully!',
		reportFailed: 'Failed to generate report, please try again later',
		reportTimeout: 'Report generation takes longer, please refresh the page later',
		operationSuccess: 'Operation successful',
		requiredField: 'Required field cannot be empty',

		// status text
		running: 'Running',
		stop: 'Stop',
		offline: 'Offline',
		normal: 'Normal',
		general: 'General',
		medium: 'Medium',
		severe: 'Severe',

		// other
		gridLayout: 'Grid Layout',
		parameterType: 'Parameter Type',
		parameterValue: 'Parameter Value',
		parameterDesc: 'Parameter Description',

		// alarm statistics dialog
		alarmStatisticsTitle: 'Alarm Statistics',
		filterConditions: 'Filter Conditions',
		department: 'Department',
		dateRange: 'Date Range',
		to: 'To',
		startDate: 'Start Date',
		endDate: 'End Date',
		query: 'Query',
		reset: 'Reset',
		statisticsResult: 'Statistics Result',
		prealarmTotal: 'Pre-alarm Total',
		diagnosisTotal: 'Diagnosis Total',
		incorrectAlarm: 'Incorrect Alarm',
		correctAlarm: 'Correct Alarm',
		incorrectDiagnosis: 'Incorrect Diagnosis',
		correctDiagnosis: 'Correct Diagnosis',
		unconfirmedAlarm: 'Unreviewed Alarm',
		unconfirmedDiagnosis: 'Unreviewed Diagnosis',
		noData: 'No Data',
		prealarmStatistics: 'Pre-alarm Statistics',
		diagnosisStatistics: 'Diagnosis Statistics',

		// list-warn component
		deviceInfoPanel: 'Device Info Panel',
		unknownDevice: 'Unknown Device',
		pointList: 'Point List',
		alarmInfo: 'Alarm Info',
		content: 'Content',
		alarmType: 'Alarm Type',
		currentPoint: 'Current Point',
		markFilter: 'Mark Filter',
		filterDisplay: 'Filter Display',
		showAll: 'Show All',
		batchConfirm: 'Batch Confirm',
		batchIgnore: 'Batch Ignore',
		batchDelete: 'Batch Delete',
		alarmId: 'Alarm ID',
		push: 'Push',
		eigenValue: 'Eigen Value',
		referenceValue: 'Reference Value',
		actualValue: 'Actual Value',
		aiModelNote: 'AI model generated, for reference only',
		modelConfig: 'Model Config',
		processSuggestionInput: 'Process Suggestion Input',
		pleaseInputSuggestion: 'Please input process suggestion',
		diagnose: 'Diagnose',
		configure: 'Configure',
		delete: 'Delete',
		review: 'Review',
		reviewResult: 'Review Result',
		diagnoseCorrect: 'Is Diagnosis Correct',
		ignoreSuccess: 'Ignored successfully',
		confirmSuccess: 'Confirmed successfully',
		configSuccess: 'Configured successfully',
		noConfigFound: 'No configuration found',
		noImage: 'No Image',
		suggestion: 'Suggestion',
		prompt: 'Prompt'
	}
}
